import { GlobalMenu } from '@components';
import { NavigationContext } from '@layout/navigation/navigation';
import EquipmentStatus from '@models/EquipmentStatus.model';
import { InviteUserRole } from '@models/Invite.model';
import { useContext } from 'react';
import { CustomStatusContext } from '../../CustomStatus.query';
import { Container } from './CustomStatusMenu.styles';

interface ICustomStatusMenu {
  equipmentStatus: EquipmentStatus;
}

const CustomStatusMenu = ({ equipmentStatus }: ICustomStatusMenu) => {
  const { openUpdateDialog, openDeleteDialog } =
    useContext(CustomStatusContext);

  const { role } = useContext(NavigationContext);

  return (
    <Container>
      <GlobalMenu
        align="end"
        title="Actions"
        itemList={[
          {
            disabled: ![InviteUserRole.ADMIN].includes(role),
            disableToolTip: [InviteUserRole.ADMIN].includes(role),
            toolTipText: 'Only admins can edit an asset status.',
            toolTipId: 'editStatusTooltip',
            label: 'Edit',
            iconName: 'edit',
            onClick: () => {
              openUpdateDialog(equipmentStatus);
            },
          },
          {
            disabled: ![InviteUserRole.ADMIN].includes(role),
            disableToolTip: [InviteUserRole.ADMIN].includes(role),
            toolTipText: 'Only admins can delete an asset status.',
            toolTipId: 'deleteStatusTooltip',
            label: 'Delete',
            iconName: 'trash',
            onClick: () => {
              openDeleteDialog(equipmentStatus);
            },
          },
        ]}
      />
    </Container>
  );
};

export { CustomStatusMenu };
